import React, { useState } from "react";
import { PasswordInput, PasswordStrength } from "./PasswordField";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { KeyRound, ShieldCheck } from "lucide-react";

const inputCls = "w-full bg-[#EDF2F4] border border-[#EBE9E4] rounded-xl focus:ring-2 focus:ring-[#0B5E4E]/20 focus:border-[#0B5E4E] outline-none transition-all px-4 py-2.5 text-sm";

export default function ForcePasswordChange() {
  const { user, refreshUser } = useAuth();
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  if (!user || !user.must_change_password) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 6) return toast.error("New password must be at least 6 characters");
    if (next !== confirm) return toast.error("Passwords do not match");
    setSaving(true);
    try {
      await api.post("/auth/change-password", { new_password: next });
      toast.success("Password updated — welcome!");
      await refreshUser();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={true}>
      <DialogContent className="[&>button]:hidden" data-testid="force-password-dialog">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <div className="h-10 w-10 rounded-xl flex items-center justify-center" style={{ background: "#0B5E4E1A" }}>
              <ShieldCheck className="h-6 w-6" style={{ color: "var(--sj-primary)" }} />
            </div>
            <DialogTitle className="font-head text-2xl">Set your password</DialogTitle>
          </div>
        </DialogHeader>
        <p className="text-sm mt-1" style={{ color: "var(--sj-text-2)" }}>
          You're signed in with your temporary password. Please choose your own password to continue.
        </p>
        <form onSubmit={submit} className="space-y-3 mt-2">
          <PasswordInput testid="fpc-new" required autoComplete="new-password" placeholder="New password (min 6 characters)" value={next} onChange={(e) => setNext(e.target.value)} className={inputCls} />
          <PasswordStrength value={next} testid="fpc-strength" />
          <PasswordInput testid="fpc-confirm" required autoComplete="new-password" placeholder="Confirm new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={inputCls} />
          <button type="submit" disabled={saving} data-testid="fpc-submit"
            className="w-full flex items-center justify-center gap-2 rounded-full px-6 py-2.5 text-white font-semibold hover:brightness-105 disabled:opacity-60" style={{ background: "var(--sj-primary)" }}>
            <KeyRound className="h-4 w-4" /> {saving ? "Saving..." : "Update password & continue"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
